import { Link } from 'react-router-dom';

import styles from '../../../../styles/Admin.module.scss';

function Item({ _id, firstName, lastName, email, membership }) {
    const statusClass = membership?.status === 'active' ? styles.active
        : membership?.status === 'past_due' ? styles.pastDue
        : null;

    return (
        <tr>
            <td>
                <Link to={_id} className={styles.tableLink}>
                    {`${firstName} ${lastName} (${email})`}
                </Link>
            </td>
            <td>{membership?.plan || '—'}</td>
            <td>
                {membership ? (
                    <span className={`${styles.membershipInfo} ${statusClass}`}>
                        {membership.status}
                    </span>
                ) : '—'}
            </td>
        </tr>
    );
}

export default Item;
